// SettingsPreferences.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const SettingsPreferencesRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalComponent
        filename="Container_ProfilePreferences"
        importer={
          /* #__LOADABLE__ */ () => import('../container/ProfilePreferences.js')
        }
      />
    </>
  );
};

export default SettingsPreferencesRoute;
